import { render } from "./FooterPanel.vue?vue&type=template&id=cbe16ea0&scoped=true"
import script from "./FooterPanel.vue?vue&type=script&lang=js"
export * from "./FooterPanel.vue?vue&type=script&lang=js"

import "./FooterPanel.scss?vue&type=style&index=0&id=cbe16ea0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe16ea0"]])

export default __exports__